import { useEffect } from 'react';
import { string } from 'prop-types';
import {
  params,
  string as stringType,
  shape as shapeType,
  arrayOf as arrayType,
  useDataModel
} from '@thd-nucleus/data-sources';
import {
  useHelmet, TitleTag, MetaTag, LinkTag
} from '@thd-nucleus/thd-helmet';

const kitchenCabinetMetadataHandler = ({ data, props }) => {
  if (!data?.fetchCollectionsContent) {
    return [];
  }

  const { fetchCollectionsContent } = data;
  const { title, media } = fetchCollectionsContent;
  const { images } = media;
  const canonical = `https://www.homedepot.com/collection/kitchen-cabinets/${props.collectionName}`;
  const SEOTitle = `${title} - Kitchen - The Home Depot`;
  const SEODescription = `Shop our Kitchen Cabinets Department to customize your ${title} today at The Home Depot`;
  const tags = [
    new TitleTag(SEOTitle),
    new MetaTag({ name: 'description', content: SEODescription, id: 'description' }),
    new MetaTag({ property: 'og:title', content: SEOTitle, id: 'ogTitle' }),
    new MetaTag({ property: 'og:url', content: canonical, id: 'ogUrl' }),
    new MetaTag({ property: 'og:image', content: images[0].url, id: 'ogImage' }),
    new MetaTag({ property: 'og:description', content: SEODescription, id: 'ogDescription' }),
    new MetaTag({ property: 'og:type', content: 'CustomKitchen', id: 'ogType' }),
    new MetaTag({ property: 'og:site_name', content: 'The Home Depot', id: 'ogSiteName' }),
    new LinkTag({ rel: 'canonical', href: canonical, id: 'canonical' })
  ];
  return tags;
};

export const KitchenCabinetMetadata = ({ collectionName }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('kitchen-cabinet-metadata.ready'); }, []);

  const kitchenCabinetOptions = {
    variables: {
      collectionName
    }
  };

  const { data } = useDataModel('fetchCollectionsContent', kitchenCabinetOptions);

  const props = {
    collectionName
  };

  useHelmet('kitchenCabinetMetadataHandler', { data, props }, kitchenCabinetMetadataHandler, [collectionName, data]);

  return null;
};

KitchenCabinetMetadata.displayName = 'KitchenCabinetMetadata';

KitchenCabinetMetadata.dataModel = {
  fetchCollectionsContent: params({ collectionName: stringType().isRequired() }).shape({
    title: stringType(),
    media: shapeType({
      images: arrayType(shapeType({
        url: stringType()
      }))
    })
  })
};

KitchenCabinetMetadata.propTypes = {
  collectionName: string.isRequired
};